<template>
  <div>
    <RequestWizard
      :activeStep.sync="activeStep"
      :form-data="formData"
      title="Submit a Freedom of Information Act (FOIA) Request"
    >
      <WelcomeStep />

      <RecordsType />

      <RequestType :requestType.sync="requestType" />

      <ContactInfo :is3rdParty="is3rdParty"
        v-model="nonCommonData.contactInfo"
      />

      <RequestDetails :requestType="requestType"
        v-bind.sync="request.common.recordDetails"
      />

      <OtherDetails v-bind.sync="request.common.otherDetails" />

      <ReviewStep v-bind="formData"
        :is3rdParty="is3rdParty"
        @go-to-step="activeStep = $event"
      />

      <template #success-message>
        <div class="small">
          <p>
            Please email <a :href="`mailto:${config.supportEmail}`"
            >{{ config.supportEmail }}</a>
            and reference the confirmation number if you need to modify or cancel your request.
          </p>

          Thank you for using the FOIA request portal for the Health Resources and Services
          Administration!
        </div>
      </template>
    </RequestWizard>
  </div>
</template>

<script>
import RequestWizard from '@/components/requestWizard';
import { flattenObj } from '@/helpers/util';
import ContactInfo from './steps/ContactInfo';
import OtherDetails from './steps/OtherDetails';
import RecordsType from './steps/RecordsType';
import RequestDetails from './steps/RequestDetails';
import RequestType from './steps/RequestType';
import ReviewStep from './steps/ReviewStep';
import WelcomeStep from './steps/WelcomeStep';

// Default values for data that varies depending on whether this is a
// 1st or 3rd-party request.
const contactInfoDefaults = {
  fromFirstName: null,
  fromLastName: null,
  fromOrganization: null,
  fromEmail: null,
  fromPhone: null,
  fromFax: null,
  fromAddressLine1: null,
  fromAddressLine2: null,
  fromCity: null,
  fromState: null,
  fromZip: null,
  onBehalfOfFirstName: null,
  onBehalfOfLastName: null,
  onBehalfOfAddressLine1: null,
  onBehalfOfAddressLine2: null,
  onBehalfOfCity: null,
  onBehalfOfState: null,
  onBehalfOfZip: null
};

export default {
  inject: ['config'],

  components: {
    ContactInfo,
    OtherDetails,
    RequestWizard,
    RecordsType,
    RequestDetails,
    RequestType,
    ReviewStep,
    WelcomeStep
  },

  data: () => ({
    activeStep: null,
    requestType: null,
    // The data to be submitted with the FOIA request.
    request: {
      firstParty: {
        contactInfo: { ...contactInfoDefaults }
      },
      thirdParty: {
        contactInfo: { ...contactInfoDefaults }
      },
      common: {
        otherDetails: {
          expeditedProcessingRequested: false,
          expeditionJustification: null,
          maxFeeAmount: null,
          feeWaiverJustification: null,
          feeWaiverRequested: false
        },
        recordDetails: {
          attachments: [],
          comments: null
        }
      }
    }
  }),

  computed: {
    formData({ nonCommonData, request }) {
      return {
        ...flattenObj(request.common),
        ...flattenObj(nonCommonData),
        // Strip out url added previously
        attachments: request.common.recordDetails.attachments
          // eslint-disable-next-line object-curly-newline
          .map(({ name, contentType, size, contents }) => ({ name, contentType, size, contents }))
      };
    },

    is3rdParty: ({ requestType }) => requestType === 'thirdParty',

    /**
     * Data that varies depending on whether this is a 1st or 3rd-party request.
     */
    nonCommonData: ({ is3rdParty, request }) => request[is3rdParty ? 'thirdParty' : 'firstParty']
  }
};
</script>
